import {
  Product,
  SoftwareApplication,
  Offer,
  PriceSpecification,
} from 'schema-dts';
import { siteUrl } from '..';

type ImergeLocalSchema = Omit<
  Partial<SoftwareApplication> & Partial<Product>,
  '@type'
> & {
  '@type': string | string[];
};

type ExtendedOffer = Offer & {
  addOn?: Offer[];
};

export const payfitProduct = (
  data: any,
  uri: string,
  localeSlug: string,
  currencyObject: { code: string; symbol: string },
): ImergeLocalSchema => {
  const description = data?.metaFields?.description;
  const newType = ['Product', 'SoftwareApplication'];

  const allOffers: ExtendedOffer[] = [];

  data?.pricing?.[0]?.pricingTable?.offers?.forEach((offerData: any) => {
    const offer = offerData.offer;

    offer.prices.forEach((price: any) => {
      const isOnDemand = price.minimumEmployees >= 25 || price.basePrice === 0;

      const priceSpec: PriceSpecification = {
        '@type': 'PriceSpecification',
        priceCurrency: currencyObject.code,
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          minValue: price.minimumEmployees,
          maxValue: price.maximumEmployees || undefined,
        },
      };

      if (isOnDemand) {
        priceSpec.description = offer.onDemandTitle || 'Price on request';
      } else {
        priceSpec.price = price.basePrice.toString();
        priceSpec.description = price.pricePerEmployeeLabel;
      }

      const addOns: Offer[] = price.optionalFeatures.map(
        (feature: any): Offer => ({
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: feature.feature.name,
            description:
              feature.feature.tooltipText.value.document.children[0].children[0]
                .value,
          },
          priceSpecification: {
            '@type': 'PriceSpecification',
            price: feature.price.toString(),
            priceCurrency: currencyObject.code,
            description: feature.priceLabel,
          },
        }),
      );

      const priceOffer: ExtendedOffer = {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: offer.title,
          description: offer.description,
        },
        name: `${offer.title} (${price.minimumEmployees}${
          price.maximumEmployees ? `-${price.maximumEmployees}` : '+'
        })`,
        description: isOnDemand
          ? `${price.basePriceLabel} - ${offer.onDemandTitle} ${price.pricePerEmployeeLabel}`
          : `${price.basePriceLabel} - ${price.basePrice} ${currencyObject.code} ${price.pricePerEmployeeLabel}`,
        priceSpecification: priceSpec,
        addOn: addOns,
      };

      allOffers.push(priceOffer);
    });
  });

  const product: ImergeLocalSchema = {
    '@type': newType,
    '@id': `${siteUrl}${uri}#product`,
    mainEntityOfPage: { '@id': `${siteUrl}${uri}` },
    name: 'Payfit App',
    brand: { '@id': `${siteUrl}/${localeSlug}#organization` },
    description: description || '',
    operatingSystem: 'Payfit',
    applicationCategory: 'Application',
    manufacturer: { '@id': `${siteUrl}/${localeSlug}#organization` },
    logo: 'https://www.datocms-assets.com/50397/1640774984-payfitlogo.svg',
    image: 'https://www.datocms-assets.com/50397/1649080514-dashboard.png',
    offers: allOffers,
  };

  return product;
};
